import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=025a45fa&"
import script from "./Empty.vue?vue&type=script&lang=js&"
export * from "./Empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('025a45fa')) {
      api.createRecord('025a45fa', component.options)
    } else {
      api.reload('025a45fa', component.options)
    }
    module.hot.accept("./Empty.vue?vue&type=template&id=025a45fa&", function () {
      api.rerender('025a45fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Empty.vue"
export default component.exports